import { Ng2StateDeclaration } from '@uirouter/angular';
import { Transition } from '@uirouter/core';

import { CommitsTabComponent } from './edit/commits-tab/trackeritem.commits-tab.component';
import { MergeTabComponent } from './edit/merge-tab/trackeritem.merge-tab.component';
import { RelatedTabComponent } from './edit/related-tab/trackeritem.related-tab.component';
import { BreakdownTabComponent } from './edit/breakdown-tab/trackeritem.breakdown-tab.component';
import { NotebookTabComponent } from './edit/notebook-tab/trackeritem.notebook-tab.component';
import { TiEditHeaderComponent } from './edit/lib/edit-header/trackeritem.edit-header.component';
import { TrackeritemEditComponent } from './edit/ti-edit.main.component';
import { TrackerItemAddComponent } from './trackerItemAdd/trackeritem.add.component';
import { TrackerItemBrowseScreenComponent } from './trackerItemBrowse/trackeritem.browse.screen.component';
import { TrackerQueryListComponent } from './trackerAdmin/trackerQueries/trackerQueryList/tracker.query.list.component';
import { TrackerQueryEditComponent } from './trackerAdmin/trackerQueries/trackerQueryEdit/tracker.query.edit.component';
import { TrackerAddComponent } from './trackerAdmin/trackerAdd/tracker.add.component';
import { TrackerAdminComponent } from './trackerAdmin/tracker.admin.component';
import { ProjectHeaderComponent } from '../../core/modules/project/projectHeader/project.header.component';

import { TrackerResolvesService } from './tracker-resolves.service';

export const TRACKER_STATES: any[] = [
    {
        name: 'home.tracker',
        url: 'tracker/:id',
        resolve: [
            {
                token: 'tracker',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.getHomepageTracker(params.id, transition);
                }
            }
        ]
    },
    {
        name: 'home.trackeritem',
        url: 'trackeritem/:id',
        resolve: [
            {
                token: 'trackerItemBasic',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.getTrackerItemBasic(params.id, params.unixName, params.tracker, transition);
                }
            }
        ],
        views: {
            'contentarea@home': {
                component: TrackeritemEditComponent
            }
        }
    },
    {
        name: 'home.project.summary.query',
        url: '/query?page_num&page_size&sort_field&sort_dir&tracker&selectedTracker&queryName&isShared',
        reloadOnSearch: false,
        resolve: [
            {
                token: 'acls',
                deps: ['project', TrackerResolvesService],
                resolveFn: async (project: any, trackerResolvesService: TrackerResolvesService) => {
                    trackerResolvesService.setAcls(project);
                    return true;
                }
            }
        ],
        params: {
            query: {
                value: '',
                squash: true
            },
            page_num: {
                value: '1',
                squash: true
            },
            page_size: {
                value: '20',
                squash: true
            },
            sort_field: {
                value: '',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            },
            queryName: {
                value: '',
                squash: true
            },
            selectedTracker: {
                value: 0,
                type: 'int',
                squash: true
            },
            tracker: {
                value: 0,
                type: 'int',
                squash: true
            },
            isShared: {
                value: '',
                squash: true
            }
        },
        views: {
            'contentarea@home.project.summary': {
                component: TrackerQueryListComponent
            }
        }
    },
    {
        name: 'home.project.summary.query.edit',
        url: '/:query/edit',
        params: {
            tracker: {
                value: 0,
                type: 'int',
                squash: true
            },
            query: {
                value: 0,
                type: 'int',
                squash: true
            }
        },
        resolve: [
            {
                token: 'acls',
                deps: ['project', TrackerResolvesService],
                resolveFn: async (project: any, trackerResolvesService: TrackerResolvesService) => {
                    trackerResolvesService.setAcls(project);
                    return true;
                }
            },
            {
                token: 'tracker',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.getTracker(params);
                }
            },
            {
                token: 'query',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.getQuery(params.tracker, params.query);
                }
            },
            {
                token: 'security',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.securityCanRead(params.tracker);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: TrackerQueryEditComponent
            }
        }
    },
    {
        name: 'home.project.summary.query.add',
        url: '/add',
        params: {
            tracker: {
                value: 0,
                type: 'int',
                squash: true
            }
        },
        resolve: [
            {
                token: 'acls',
                deps: ['project', TrackerResolvesService],
                resolveFn: async (project: any, trackerResolvesService: TrackerResolvesService) => {
                    trackerResolvesService.setAcls(project);
                    return true;
                }
            },
            {
                token: 'tracker',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.getTracker(params);
                }
            },
            {
                token: 'query',
                deps: [TrackerResolvesService],
                resolveFn: async (trackerResolvesService: TrackerResolvesService) => {
                    return trackerResolvesService.getNewQuery();
                }
            },
            {
                token: 'security',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.securityCanRead(params.tracker);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: TrackerQueryEditComponent
            }
        }
    },
    {
        name: 'home.project.summary.tracker',
        abstract: true,
        url: '/tracker/:tracker',
        data: {
            searchContext: ['trackeritem']
        },
        resolve: [
            {
                token: 'acls',
                deps: ['project', TrackerResolvesService],
                resolveFn: async (project: any, trackerResolvesService: TrackerResolvesService) => {
                    trackerResolvesService.setAcls(project);
                    return true;
                }
            },
            {
                token: 'queries',
                deps: ['$transition$', 'project', TrackerResolvesService],
                resolveFn: async (transition: any, project: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.getProjectQueries(params.tracker, project);
                }
            },
            {
                token: 'tracker',
                deps: ['$transition$', 'queries', TrackerResolvesService],
                resolveFn: async (transition: any, queries: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.getTrackerWithValidation(params.unixName, params.tracker, queries);
                }
            },
            {
                token: 'security',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.securityCanRead(params.tracker);
                }
            }
        ]
    },
    {
        name: 'home.project.summary.tracker.browse',
        url: '/browse?query&page_size&page_num&sort_field&sort_dir&view&r&c&filters',
        reloadOnSearch: false,
        params: {
            page_num: {
                value: 1,
                type: 'int',
                squash: true
            },
            page_size: {
                value: 20,
                type: 'int',
                squash: true
            },
            query: {
                value: '',
                squash: true
            },
            sort_field: {
                value: 'id',
                squash: true
            },
            sort_dir: {
                value: 'ASC',
                squash: true
            },
            view: {
                value: 'grid',
                squash: true
            },
            r: {
                value: '',
                squash: true
            },
            c: {
                value: 'status',
                squash: true
            },
            filters: {
                value: null,
                squash: true,
                dynamic: true,
                raw: true
            }
        },
        resolve: [
            {
                token: 'queryId',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.getQueryPreference(params);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: TrackerItemBrowseScreenComponent
            }
        }
    },
    {
        name: 'home.project.summary.tracker.item',
        abstract: true,
        url: '/item',
        data: {
            searchContext: ['trackeritem']
        }
    },
    {
        name: 'home.project.summary.tracker.item.add',
        url: '/add',
        params: {
            query: {
                value: '',
                dynamic: true
            }
        },
        resolve: [
            {
                token: 'acls',
                deps: ['project', TrackerResolvesService],
                resolveFn: async (project: any, trackerResolvesService: TrackerResolvesService) => {
                    trackerResolvesService.setAcls(project);
                    return true;
                }
            },
            {
                token: 'security',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.securityCanSubmit(params.tracker);
                }
            },
            {
                token: 'tour',
                deps: [TrackerResolvesService],
                resolveFn: async (trackerResolvesService: TrackerResolvesService) => {
                    return trackerResolvesService.getTrackerItemAddTour();
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: TrackerItemAddComponent,
                bindings: {
                    tracker: 'tracker',
                    project: 'project',
                    projectMenu: 'projectMenu',
                    siteConfig: 'siteConfig'
                }
            }
        }
    },
    {
        name: 'home.project.summary.tracker.item.edit',
        url: '/edit/:id',
        resolve: [
            {
                token: 'acls',
                deps: ['project', 'trackeritem', TrackerResolvesService],
                resolveFn: async (project: any, trackeritem: any, trackerResolvesService: TrackerResolvesService) => {
                    return trackerResolvesService.getTrackerItemAcls(project, trackeritem);
                }
            },
            {
                token: 'security',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.securityCanRead(params.tracker);
                }
            },
            {
                token: 'trackeritem',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.getTrackerItemDetails(params.id, transition);
                }
            }
        ],
        views: {
            'projectheader@home.project.summary': {
                component: TiEditHeaderComponent
            },
            'contentarea@home.project.summary': {
                component: TrackeritemEditComponent
            }
        }
    },
    {
        name: 'home.project.summary.tracker.item.edit.commits',
        url: '/commits',
        resolve: [
            {
                token: 'tiWithCommits',
                deps: ['trackeritem', TrackerResolvesService],
                resolveFn: async (trackeritem: any, trackerResolvesService: TrackerResolvesService) => {
                    return trackerResolvesService.getTrackerItemWithCommits(trackeritem);
                }
            },
            {
                token: 'tiMerge',
                deps: ['trackeritem', TrackerResolvesService],
                resolveFn: async (trackeritem: any, trackerResolvesService: TrackerResolvesService) => {
                    return trackerResolvesService.getTrackerItemMerge(trackeritem);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: CommitsTabComponent
            }
        }
    },
    {
        name: 'home.project.summary.tracker.item.edit.merge',
        url: '/merge',
        resolve: [
            {
                token: 'tiMerge',
                deps: ['trackeritem', TrackerResolvesService],
                resolveFn: async (trackeritem: any, trackerResolvesService: TrackerResolvesService) => {
                    return trackerResolvesService.getTrackerItemMerge(trackeritem);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: MergeTabComponent
            }
        }
    },
    {
        name: 'home.project.summary.tracker.item.edit.related',
        url: '/related',
        resolve: [
            {
                token: 'tiWithRelated',
                deps: ['trackeritem', TrackerResolvesService],
                resolveFn: async (trackeritem: any, trackerResolvesService: TrackerResolvesService) => {
                    return trackerResolvesService.getTrackerItemWithRelated(trackeritem);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: RelatedTabComponent
            }
        }
    },
    {
        // #65237 Iteration 3: reachable only by direct URL -- deliberately not yet added to the
        // tab strip nav (trackeritem.edit-header.component.ts/.html); Iteration 5 wires that up.
        name: 'home.project.summary.tracker.item.edit.breakdown',
        url: '/breakdown',
        resolve: [
            {
                token: 'tiWithChildren',
                deps: ['trackeritem', TrackerResolvesService],
                resolveFn: async (trackeritem: any, trackerResolvesService: TrackerResolvesService) => {
                    return trackerResolvesService.getTrackerItemWithChildren(trackeritem);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: BreakdownTabComponent
            }
        }
    },
    {
        name: 'home.project.summary.tracker.item.edit.notebook',
        url: '/notebook/{pagename}',
        params: {
            pagename: {
                value: null,
                squash: true,
                dynamic: true
            }
        },
        resolve: [],
        views: {
            'contentarea@home.project.summary': {
                component: NotebookTabComponent
            }
        }
    },
    {
        name: 'home.project.summary.trackeradmin',
        url: '/trackeradmin/:tracker?tab&workflowField',
        params: {
            tab: {
                value: 'tab-main-settings',
                squash: true
            },
            workflowField: {
                value: '',
                squash: true
            }
        },
        resolve: [
            {
                token: 'acls',
                deps: ['project', TrackerResolvesService],
                resolveFn: async (project: any, trackerResolvesService: TrackerResolvesService) => {
                    trackerResolvesService.setAcls(project);
                    return true;
                }
            },
            {
                token: 'tracker',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.getTracker(params);
                }
            },
            {
                token: 'tour',
                deps: [TrackerResolvesService],
                resolveFn: async (trackerResolvesService: TrackerResolvesService) => {
                    return trackerResolvesService.getTrackerAdminTour();
                }
            },
            {
                token: 'security',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.securityCanRead(params.tracker);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: TrackerAdminComponent
            }
        }
    },
    {
        name: 'home.project.summary.tracker_add',
        url: '/add',
        resolve: [
            {
                token: 'acls',
                deps: ['project', TrackerResolvesService],
                resolveFn: async (project: any, trackerResolvesService: TrackerResolvesService) => {
                    trackerResolvesService.setAcls(project);
                    return true;
                }
            },
            {
                token: 'security',
                deps: ['$transition$', TrackerResolvesService],
                resolveFn: async (transition: any, trackerResolvesService: TrackerResolvesService) => {
                    const params = transition.params();
                    return trackerResolvesService.securityCanRead(params.tracker);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: TrackerAddComponent,
                bindings: {
                    project: 'project',
                    siteConfig: 'siteConfig'
                }
            }
        }
    }
];
